module.exports = __webpack_public_path__ + "static/media/AffinityTech-InsureComp.71773dad.png";